import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=80537cdc&"
import script from "./Status.vue?vue&type=script&lang=js&"
export * from "./Status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports